/* eslint-disable import/prefer-default-export */
import dayjs from 'dayjs';

export function TimeFilter(v, format = 'YYYY-MM-DD HH:mm:ss') {
  if (!v) {
    return '';
  }
  return dayjs(v).format(format);
}
